import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Settings, Globe, Users, Receipt, Phone, Bell, ArrowLeft, LogOut } from "lucide-react";

export default function AdminLayout({ children }) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 text-sm transition-colors border-l-2 ${
      isActive
        ? "bg-white/5 text-white border-[hsl(221,83%,53%)]"
        : "text-white/60 hover:text-white hover:bg-white/[0.03] border-transparent"
    }`;

  return (
    <div className="min-h-screen bg-[hsl(0,0%,4%)] text-white flex">
      <aside className="w-60 border-r border-white/10 flex flex-col">
        <div className="p-6 border-b border-white/10">
          <Link to="/yonetimvolki35" className="font-display font-black text-lg tracking-tight" data-testid="admin-brand">
            SMS<span className="text-[hsl(221,83%,63%)]">KAPIDA</span>
          </Link>
          <div className="text-[10px] uppercase tracking-[0.2em] text-white/40 mt-1">Admin Konsol</div>
        </div>
        <nav className="py-4 flex-1">
          <NavLink to="/yonetimvolki35" end className={linkClass} data-testid="admin-nav-dashboard">
            <LayoutDashboard className="w-4 h-4" /> Panel
          </NavLink>
          <NavLink to="/yonetimvolki35/transactions" className={linkClass} data-testid="admin-nav-transactions">
            <Receipt className="w-4 h-4" /> Bakiye Onayları
          </NavLink>
          <NavLink to="/yonetimvolki35/users" className={linkClass} data-testid="admin-nav-users">
            <Users className="w-4 h-4" /> Kullanıcılar
          </NavLink>
          <NavLink to="/yonetimvolki35/numbers" className={linkClass} data-testid="admin-nav-numbers">
            <Phone className="w-4 h-4" /> Numaralar
          </NavLink>
          <NavLink to="/yonetimvolki35/countries" className={linkClass} data-testid="admin-nav-countries">
            <Globe className="w-4 h-4" /> Ülkeler
          </NavLink>
          <NavLink to="/yonetimvolki35/settings" className={linkClass} data-testid="admin-nav-settings">
            <Settings className="w-4 h-4" /> Ayarlar
          </NavLink>
          <NavLink to="/yonetimvolki35/notifications" className={linkClass} data-testid="admin-nav-notifications">
            <Bell className="w-4 h-4" /> Bildirimler
          </NavLink>
        </nav>
        <div className="p-4 border-t border-white/10 space-y-2">
          <Link to="/" className="flex items-center gap-2 text-xs text-white/50 hover:text-white transition-colors" data-testid="admin-back-user">
            <ArrowLeft className="w-3 h-3" /> Kullanıcı paneline dön
          </Link>
          <button
            onClick={() => { logout(); navigate("/login"); }}
            data-testid="admin-logout-btn"
            className="flex items-center gap-2 text-xs text-white/60 hover:text-white transition-colors"
          >
            <LogOut className="w-3 h-3" /> Çıkış Yap
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-auto">
        <div className="p-8 max-w-6xl">{children}</div>
      </main>
    </div>
  );
}
